/*
 * @description: 公共接口
 * @author: Jsj
 * @Compile：2021-01-20 18：00
 * @update: Jsj(2021-01-20 18：00)
 */
import axios from "@/utils/request";

/**
 * @memo 上传单个图片
 * @param files  //类型：文件  必有字段  备注：需要上传的图片
 */
export function file_upload_image_path(files) {
  return axios({
    url: "/v1/file/uploadImage",
    method: "post",
    files
  });
}

/**
 * @memo 上传多个图片
 * @param files  //类型：文件  必有字段  备注：需要上传的图片
 */
export function file_multi_upload_path(files) {
  return axios({
    url: "/v1/file/uploadImage",
    method: "post",
    files
  });
}

/**
 * 删除图片 暂时不使用
 */
export function delete_file_path(data) {
  return axios({
    url: "/api/upload/deleteFile",
    method: "post",
    data
  });
}

/**
 * @memo 字典获取
 * @param data
 * parentKey:"1023"  获取等级接口
 */
export function get_dictionary_path(data) {
  return axios({
    url: "/v1/dictionary/getDictionaryInfoByParentCode",
    method: "post",
    data
  });
}
